import { DataProxy } from 'apollo-cache';
import produce, { Draft } from 'immer';

import {
  ClientDisclosureFragment,
  ClientDisclosureList,
  ClientProtectedFragment,
  ClientProtectedFragmentDoc,
  GetAllClientDisclosuresDocument,
  GetAllClientDisclosuresQuery,
} from 'api';

interface IReducer {
  cache: DataProxy;
  client_id: ClientProtectedFragment['id'];
  result: ClientDisclosureFragment;
}

interface IReducers {
  createDisclosureOnClient: (
    fragment: ClientProtectedFragment,
    result: ClientDisclosureFragment,
  ) => ClientProtectedFragment;
  createDisclosureOnQuery: (
    fragment: ClientDisclosureList,
    result: ClientDisclosureFragment,
  ) => ClientDisclosureList;
}

const reducers: IReducers = {
  createDisclosureOnClient: produce((fragment: Draft<ClientProtectedFragment>, result) => {
    fragment.disclosures.unshift({
      ...result,
      __typename: 'ClientDisclosure',
    });
    return fragment;
  }),
  createDisclosureOnQuery: produce((fragment: Draft<ClientDisclosureList>, result) => {
    fragment.client_disclosures.unshift({
      ...result,
      __typename: 'ClientDisclosure',
    });
    return fragment;
  }),
};

export default (options: IReducer) => {
  const { cache, client_id, result } = options;

  const queryOptions = {
    query: GetAllClientDisclosuresDocument,
    variables: { data: {} },
  };
  const clientFragment: ClientProtectedFragment = cache.readFragment({
    id: `Client:${client_id}`,
    fragment: ClientProtectedFragmentDoc,
    fragmentName: 'ClientProtected',
  });

  const { getAllClientDisclosures }: GetAllClientDisclosuresQuery = cache.readQuery(queryOptions);

  if (!clientFragment || !getAllClientDisclosures) {
    return;
  }

  cache.writeFragment({
    id: `Client:${client_id}`,
    fragment: ClientProtectedFragmentDoc,
    fragmentName: 'ClientProtected',
    data: reducers.createDisclosureOnClient(clientFragment, result),
  });

  cache.writeQuery({
    ...queryOptions,
    data: {
      getAllClientDisclosures: reducers.createDisclosureOnQuery(getAllClientDisclosures, result),
    },
  });
};
